    <template>
        <!-- Start Main Content -->
        <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
            <div class="card">
                <h2 class="card-title">Salary Report</h2>
            </div>

        

                <div class="card">

                    <div class="row" style="display: flex; gap: 1rem;">

                        <div class="mt-2">
                                <label for="tagname" class="form-label">From Date *</label>
                                <input type="date" v-model="filter.fromdate" class="form-input" id="first_input" autocomplete="off" required >
                            </div>


                            <div class="mt-2">
                                <label for="tagname" class="form-label">To Date *</label>
                                <input type="date" v-model="filter.todate" class="form-input" id="first_input" autocomplete="off" required >
                            </div>

                            <div class="mt-2">
                                                <label for="mainemployee" class="form-label">Search Employee</label><br>
                                                <select class="form-select form-select-sm" id="mainemployee" ref="mainemployee" v-model="filter.empid">
                                                    <option value="0" v-if="selected_employee_id==0" selected disabled>SELECT EMPLOYEE</option>
                                                    <option v-for="(item, index) in EmployeeList" :key="index" :value="item.id">{{ item.empname }}</option>
                                                </select>
                                            </div>


                        <div class="mt-6">
                                <button @click="filter_list" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Filter</button>
                            </div> 


                    
                            </div>

        



                        </div>

    <div class="card">
                    <div class="row" style="display: flex; gap: 1rem;">
            <button @click="printTable" class="btn b-solid btn-secondary-solid cursor-pointer shadow-sm ml-2">Print</button>
            
                <button @click="salaryModal()" class="btn b-solid btn-danger-solid cursor-pointer shadow-sm ml-2">Add Voucher</button> 
            </div>
            </div>


            <div class="grid grid-cols-12">
                <!-- INITIALIZE CSS CLASS -->
                <div class="hidden">
                    <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                    <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                    <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                    <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                    <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
                </div>
                <!-- INITIALIZE CSS CLASS -->
                <div class="tablejs sr-only size-0"></div>
                <!-- BASIC DATA TABLE -->
                <div class="col-span-full">
                    <div class="card p-0">
                        <div class="p-6 space-y-4">
                            <div id="printArea">
                            <table id="datatable" class="datatable">
                                <thead>
                                    <tr>
                                        <th class="bg-[#B2E8D9]">Tr.Id.</th>
                                        <th class="bg-[#B2E8D9]">Entry Date</th>
                                        <th class="bg-[#B2E8D9]">Employee Name</th>
                                        <th class="bg-[#B2E8D9] text-danger">Total</th>
                                        <th class="bg-[#B2E8D9] text-info">Paid</th>
                                        <th class="bg-[#B2E8D9]">Balance</th> 
                                        <th class="bg-[#B2E8D9]">Note</th> 
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                    <tr v-for="(item ,index)  in salaryList" :key="item.id">
                                        <td>{{item.id}}</td>
                                        <td>{{item.entrydate}}</td>
                                        <td>
                                        <router-link :to="`/emphistory?q=${item.empid}`" class="text-black-500 underline">
                                        {{ item.emp_name }}
                                        </router-link>
                                        </td>
                                        <td class=" text-danger">{{item.total}}</td>
                                        <td class=" text-info">{{item.paid}}</td>
                                        <td class=" text-success">{{item.balance}}</td> 
                                        <td>{{item.note}}</td> 
                                    </tr> 
                                </tbody>
                                <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                    <tr style="background:rgb(226 232 240 / 0.5)">
                                        <td colspan="3"></td>
                                        <td class="text-danger">{{Final.total}}</td>
                                        <td class=" text-info">{{Final.paid}}</td>
                                        <!-- <td class=" text-success">{{Final.balance.toFixed(2)}}</td> -->
                                    </tr>
                                </tfoot>





                            </table>
                            </div>
                        </div>
                        <!-- Prism Code -->
                        <div class="p-6 hidden">
                            <pre>
                                <code class="language-markup">
                                    &lt;p>Sorry we can't show the huge data table&lt;/p>
                                </code>
                            </pre>
                        </div>
                        <!-- Prism Code -->
                    </div>
                </div>
                <!-- BORDERED SELECTION DELETION DATA TABLE -->
                
            </div>
        </div>
        <!-- End Main Content -->
        <!-- Start Delete Modal -->
        <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
            <div class="p-4 w-full max-w-md max-h-full">
                <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                    <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                        <i class="ri-close-line text-inherit text-xl leading-none"></i>
                    </button>
                    <div class="p-4 md:p-5 text-center">
                        <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                        <div class="mt-5 text-center">
                            <h5 class="mb-1">Are you sure?</h5>
                            <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                            <div class="flex justify-center gap-2 mt-6">
                                <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                                <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End Delete Modal -->

    <!-- modal -->
    <div id="salaryModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
            <div class="p-4 w-full max-w-lg max-h-full">
                <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                    <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                        <i class="ri-close-line text-inherit text-xl leading-none"></i>
                    </button>
                    <div class="p-4 md:p-5">

                                <div class="mt-2">
                                                <label for="employee" class="form-label">Search Employee</label><br>
                                                <select class="form-select form-select-sm" id="employee" v-model="salary.empid" ref="salary1" @change="$refs.salary2.focus()"  @keydown.enter.prevent="$refs.salary2.focus()">
                                                    <option value=""></option>
                                                    <option v-for="(item, index) in EmployeeList" :key="index" :value="item.id"  >{{ item.empname }}</option>
                                                </select>
                                            </div>



                        <div class="mt-7">
                                <label for="tagname" class="form-label">Entry Date *</label>
                                <input type="date" v-model="salary.entrydate" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary2" @keyup.enter="$refs.salary3.focus()" required >
                            </div>
                    
                            <div class="mt-7">
                                <label for="tagname" class="form-label">Paid *</label>
                                <input type="number" v-model="salary.paid" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary3" @keyup.enter="$refs.salary4.focus()" required >
                            </div>


                        <div class="mt-7">
                                <label for="tagname" class="form-label">Total *</label>
                                <input type="number" v-model="salary.total" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary4" @keyup.enter="$refs.salary5.focus()" required >
                            </div>

                            <div class="mt-7">
                                <label for="tagname" class="form-label">Note *</label>
                                <input type="text" v-model="salary.note" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary5" @keyup.enter="$refs.savebtn.focus()" required >
                            </div>

                            <div class="flex justify-end mt-7">
                                <button @click="save_salary" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" ref="savebtn">Save</button>
                            </div> 
                    </div>
                </div>
            </div>
        </div>
    <!-- modal -->










    </template>

    <script>
    // @ is an alias to /src
    // import HelloWorld from '@/components/HelloWorld.vue'
    import axios from 'axios';

    export default {
    name: 'DeliveryReport',
    components: {
    
    } ,
    mounted(){

        if (this.$route.query.q) {
            this.selected_employee_id=this.$route.query.q;
            this.getBasics(this.$route.query.q);

        }else{
        this.getBasics();
        }
    },
    data() {
    return {
        selected_employee_id:'',
        isAdd:0,
        isEdit:0,
        isDelete: 0,
        deleteId: 0,
        salaryList:[],
        datatable:null,
        product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
        employees: {empname:'',emprole:'0',isMainAdmin:0},
        filter:{
            fromdate:this.todayDate(),
            todate:this.todayDate(),
            empid:'',
        },
        EmployeeList:[],

        Final:{total:0,paid:0},

        filterwise:{
            billno:''
        },
        filterpurwise:{
            purno:''
        },
            salary:{
                entrydate:this.todayDate(),
                paid:'',
                total:'',
                note:'',
                empid:''
            },


    }
    }, 
    methods:{
    closeModal(){
        
        $("#editModal").addClass('hidden');
                $("#deleteModal").addClass('hidden');
                    $("#salaryModal").addClass('hidden');
            this.isAdd=0;
            this.isEdit=0;
            this.isDelete=0;
            this.deleteId=0;
    },
    addModal(){
        this.cat={name:'',status:'Active'};
        if(!this.isAdd)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
        this.isAdd=!this.isAdd;
    },

    editModal(item){
        if(item){
            let copy = JSON.parse(JSON.stringify(item));
            this.cat=copy;
        }
        if(!this.isEdit)
            $("#editModal").removeClass('hidden');
        else
            $("#editModal").addClass('hidden');
        this.isEdit=!this.isEdit;
    },
    
    deleteModal(id){
        this.deleteId=id;
        if(!this.isDelete)
            $("#deleteModal").removeClass('hidden');
        else
            $("#deleteModal").addClass('hidden');
        this.isDelete=!this.isDelete;
    },
    async getBasics(id) {
        var self=this;
            axios.post('getsalaryAccounting',{id:id}).then(function (response) {
                self.destroyTable();
                    self.salaryList=response.data.salaryList;
                    self.employees=response.data.userDetails;
                    self.EmployeeList=response.data.EmployeeList;
                    if(self.selected_employee_id>0){
                        self.EmployeeList= self.EmployeeList.filter(employee => 
                                employee.id==self.selected_employee_id
                                );
                    }
                    }).then(()=>{ 
                    var self=this;





                $("#mainemployee").select2({
                            width: '250px', 
                            placeholder:"Search Employee Here...",
                        "language": {
                                    "noResults": function(){
                                        return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                    }
                                },
                                    escapeMarkup: function (markup) {
                                        return markup;
                                    }
                        }).on('change', function (event) {
                        //  alert(event.target.value);
                                self.filter.empid=event.target.value; 
                                    
                                
                            });
                                    if (this.$route.query.q) {
                            $('#mainemployee').val(this.$route.query.q).trigger('change');
                        }




                            $("#employee").select2({
                            width: '450px', 
                            placeholder:"Search Employee Here...",
                        "language": {
                                    "noResults": function(){
                                        return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                    }
                                },
                                    escapeMarkup: function (markup) {
                                        return markup;
                                    }
                        }).on('change', function (event) {
                        //  alert(event.target.value);
                                self.salary.empid=event.target.value; 
                                    
                                
                            });

                            if (this.$route.query.q) {
                            $('#employee').val(this.$route.query.q).trigger('change');
                        }


            self.refreshTable();
            self.calculateTotal();




                
                        });;
    }, 
    async filterCustomer(custid) {
        var self=this;
            axios.post('getCustomerSales',{custid:custid}).then(function (response) {
                    self.destroyTable();

                    self.salaryList=response.data.salaryList;
                    self.employees=response.data.userDetails;
                    }).then(()=>{ 
                        self.refreshTable();

                        self.calculateTotal();


                    // $(".datatable").DataTable().destroy();

                        // self.datatable= $(".datatable").DataTable({
                        //         "paging": true,
                        //         "ordering": true,  
                        //         "autoWidth": false });

                
                        });;
    }, 
                




        todayDate() {
                    var today = new Date();
                    var month = today.getMonth() + 1;

                    return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

                },






    async filter_list() {
        var self=this;
            axios.post('getfiltersalary',self.filter).then(function (response) {
                self.destroyTable();


                    self.salaryList=response.data.salaryList;
                    self.employees=response.data.userDetails;
                    self.customerList=response.data.customerList;


                    }).then(()=>{ 


                    self.refreshTable();
                        self.calculateTotal();

                
                        });;
    }, 



    destroyTable(){
        if ($.fn.dataTable.isDataTable('.datatable')) {
                            $('.datatable').DataTable().destroy();
                        }
    },
        refreshTable(){
                        self.datatable= $(".datatable").DataTable({
                                "paging": true,
                                "ordering": true,  
                                "autoWidth": false,
                                "order": []
                                });
                
                    
    },

                calculateTotal(){
                var self=this;
                self.Final=  {total:0,paid:0};


                    Array.from(self.salaryList).forEach((row) => {
                    self.Final.total+=parseFloat(row.total);
                    self.Final.paid+=parseFloat(row.paid);


                    });
                },




    delete_category() {
                    var self = this; 
                    axios.post('deleteProduct', {deleteId:this.deleteId})
                        .then(response => {
                            self.salaryList=response.data.products;
                            self.employees=response.data.userDetails; 
                            self.closeModal(); 
                        })
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });
                },


    printTable() {
        window.print();
    },


    
    salaryModal(){

        $("#salaryModal").removeClass('hidden');
        
        },

        save_salary() {
                    var self = this;

                    if(self.salary.empid==''){
                    self.$swal("Select Employee Required");
                    }
                    else if(self.salary.entrydate==''){
                        self.$swal("Entry Date Required");
                    }else if(self.salary.paid === '' && self.salary.total === '' ){
                         self.$swal(" Paid OR Total Required");                          
                    }   
                    else {
                    axios.post('save_salary_accounting', this.salary)
                        .then(response => {
                                 self.destroyTable();
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                        self.salaryList=response.data.salaryList;
                        self.employees=response.data.userDetails;
                        self.EmployeeList=response.data.EmployeeList;
                
                        self.salary={entrydate:'',paid:'', total:'',note:'',},

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        }).then(()=>{ 
                        self.refreshTable();
                          })    
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });

                    }
                },



    








    }
    }
    </script>
    <style scoped>
    @media print {
        body * {
            visibility: hidden;
        }
        #printArea, #printArea * {
            visibility: visible;
        }
        #printArea {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
        }
    }
    </style>